import type { MailboxImportBody } from '@vivport/backend/types';
import { KeepActions, type KeptRef } from '@/components/keep/KeepActions';
import { useKeepMailboxMessages } from '@/hooks/useMemberExternalAccountQueries';

export interface MailboxKeepActionsProps {
  accountId: number;
  providerMessageIds: string[];
  kept: KeptRef | null;
  scope: 'message' | 'conversation';
}

export function MailboxKeepActions({ accountId, providerMessageIds, kept, scope }: MailboxKeepActionsProps) {
  const keepMutation = useKeepMailboxMessages(accountId);
  const baseBody: MailboxImportBody =
    scope === 'conversation' ? { providerMessageIds, expandThreads: false } : { providerMessageIds };
  const count = providerMessageIds.length;
  const description =
    scope === 'conversation'
      ? `${count} message${count === 1 ? '' : 's'} in this conversation`
      : `${count} message${count === 1 ? '' : 's'}`;

  return (
    <KeepActions
      kept={kept}
      onKeep={(anchorId) => keepMutation.mutate(anchorId !== undefined ? { ...baseBody, anchorId } : baseBody)}
      pending={keepMutation.isPending}
      error={keepMutation.error}
      label={scope === 'conversation' ? 'Keep conversation' : 'Keep'}
      description={description}
    />
  );
}
